import { Box, Icon } from '@rbilabs/universal-components';

import { theme } from 'styles/theme';

export const DeliveryProgressContainer = Box.withConfig({
  w: { base: 'full', md: '1/2' },
  height: '$9',
});

export const ProgressContainer = Box.withConfig({
  position: 'relative',
});

export const IconContainer = Box.withConfig({
  position: 'relative',
  backgroundColor: Styles.color.primary,
  borderRadius: 'full',
  w: '$8',
  bottom: '$6',
});

export const DeliveryIcon = Icon.withConfig({
  variant: 'delivery',
  size: 6,
  color: theme.primitives.colors.white,
  m: '$1',
});
